import Button from 'components/form-elements/buttons/Button'
import Checkbox from 'components/form-elements/checkbox/Checkbox'
import Input from 'components/form-elements/input/Input'
import { useRequest } from 'hooks/useRequest'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
// import { Link } from 'react-router-dom'
import { stages } from 'utils/Constants'
import useToast from 'hooks/useToast';
import LoaderTwo from 'pages/LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import {dataLayerPush} from 'utils/Datalayer'
import auth from 'utils/Auth'

const StagePassword = ({ setRegisterState }) => {

  const { register } = useSelector((state) => state)
  const [request,loading] = useRequest()
  const { showToast } = useToast()

  const [passwd, setPasswd] = useState()
  const [remember, setRemember] = useState(false)
  const {t} = useTranslate()

  const skipStage2 = () => {
    setRegisterState(stages.STAGE_TYPE_SELECTION)
  }
	const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA

  const login = async() => {
    await window.grecaptcha.ready(function () {
      window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function (token) {
    request('/InternalAuth/InternalLogin', {
      method: 'POST',
      data: {
        email: register.registerDataMail,
        password: passwd,
        rememberMe : remember,
        token: token,
      },

    }).then((res) => {

      if (res?.data) {
        if (res?.data?.ok == true) {
          if (res?.data?.result) {
            localStorage.setItem('auth', JSON.stringify(res?.data?.result))
             const userInfo = auth.getUserInfoFromToken()
            
            dataLayerPush({
              event:"login",
              user_email:register.registerDataMail,
              login_type:t('loginBtn'),
              user_id: userInfo?.nameid
            })
            showToast(t('successLogin'), 'success')
            skipStage2();
          }
        } else {

          showToast(res?.data?.metadata?.message, 'warning')

        }
      }

    })

  })
})
  }


  const password = (e, name) => {
    if (name) {
      setPasswd((prev) => ({ ...prev, [name]: e }))
    }
    else {
      setPasswd(e.target.value)
    }
  }



  return (
    <div className="d-flex flex-column gap-4 m-auto register-container">
      <LoaderTwo isDataLoading={loading} />
      <div className="header-m">
        {register?.registerData?.firstName && register?.registerData?.lastName ? `${register.registerData?.firstName} ${register?.registerData?.lastName}` :
          register?.registerDataMail ? register?.registerDataMail : ''}
      </div>
      <h1 className="header-l">
       {t('welcome')}
      </h1>
      <Input containerClassName={"m-0"}
        className={''} placeholder={t('labelPassword')}
        type={'password'} textLabel={t('labelPassword')}
        name='password'
        value={passwd}
        required
        onChange={password}
      />
      <Checkbox onChange={e => setRemember(e.target.checked)} className={'m-0'} textLabel={t('rememberMe')} />
      <Button onClick={login} text={t('continue')} className={"claretredRoundedBtn m-0"} />
      <span onClick={() => setRegisterState(stages.STAGE_FORGOT_PASSWORD)} className='body-s w-100 d-flex justify-content-center cursor-pointer'>
        {t('forgotPassword')}
      </span>
      {/* <Link to={'/forgot'} className='body-s w-100 d-flex justify-content-center'>
        Şifremi Unuttum
      </Link> */}
    </div>
  )
}

export default StagePassword